import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { LicenseHostMapFrontDoorState } from '@portal-core/license-host-maps/models/license-host-map-front-door-state.model';

@CollectionStateSelectors({
  stateType: LicenseHostMapsFrontDoorState
})
@State<LicenseHostMapsFrontDoorState>({
  name: LicenseHostMapsFrontDoorState.source
})
@Service({ autoProvided: false })
export class LicenseHostMapsFrontDoorState extends CollectionStateBase {
  static override source: string = 'LicenseHostMapsFrontDoor';
  getSource(): string {
    return LicenseHostMapsFrontDoorState.source;
  }
}

@Service()
export class LicenseHostMapsFrontDoorDataService extends CollectionDataServiceBase<LicenseHostMapFrontDoorState> {
  protected readonly stateType = LicenseHostMapsFrontDoorState;
}
